
const UlAccords = (target) => {
  const listItems = target.querySelectorAll(".ulaccord__item");
  const deliveryElement = document.querySelector(".cartlist__delivery");

  const method = {

    init: () => {
      listItems.forEach((item) => {
        item.addEventListener("change", method.changed);
      });
    },
    changed: (e) => {
      if (!e.currentTarget.classList.contains("ulaccord__item--open")) {
        method.closeAll();
      }
      e.currentTarget.classList.add("ulaccord__item--open");

      if (deliveryElement) {
        const currentInputElement = e.currentTarget.querySelector("input");

        if (currentInputElement && currentInputElement.value === "sent") {
          deliveryElement.classList.remove("cartlist__price--hidden");
        } else {
          deliveryElement.classList.add("cartlist__price--hidden");
        }
      }
    },
    closeAll: () => {
      listItems.forEach((item) => {
        item.classList.remove("ulaccord__item--open");
      });
    },
  };

  if (listItems.length > 0) {
    method.init();
  }
};

export default UlAccords;
